(() => {
  if (window.fifthAvenueUpsellLoaded) return;
  window.fifthAvenueUpsellLoaded = true;

  const root = window.Shopify?.routes?.root || "/";
  const selector = ".theUcbInputCbox[data-ucb-parent]";
  const source = "fifth-avenue-upsell";
  let cartState;
  let queue = Promise.resolve();
  let pendingSelections = 0;
  const lockedForms = new Map();

  function lockProductForms() {
    if (!pendingSelections) return;
    document.querySelectorAll("product-form").forEach((form) => {
      if (!form.querySelector(selector)) return;
      if (!lockedForms.has(form)) lockedForms.set(form, form.inert);
      form.inert = true;
    });
  }

  function releaseProductForms() {
    pendingSelections -= 1;
    if (pendingSelections) return;
    lockedForms.forEach((wasInert, form) => { form.inert = wasInert; });
    lockedForms.clear();
  }

  function nativeAddPending() {
    return [...document.querySelectorAll("product-form")].some((form) => {
      const button = form.submitButton || form.querySelector('[type="submit"]');
      return button?.classList?.contains("loading");
    });
  }

  function enqueue(task) {
    const result = queue.then(task);
    queue = result.catch(() => {});
    return result;
  }

  async function request(path, body) {
    const options = body ? {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    } : {};
    const response = await fetch(root + path, options);
    const data = await response.json();
    if (!response.ok || data.errors || data.status >= 400) {
      throw new Error(data.description || data.message || window.cartStrings?.error || "Unable to update your cart.");
    }
    return data;
  }

  const isAddon = (item) => item.properties?._ucbProduct === "yes";
  const parentIds = (cart) => new Set((cart?.items || []).filter((item) => !isAddon(item)).map((item) => String(item.product_id)));
  const matches = (item, parent, variant) => isAddon(item) && String(item.properties._refProdId) === String(parent) && String(item.variant_id) === String(variant);

  function synchronize(cart) {
    if (!cart) return;
    document.querySelectorAll(selector).forEach((input) => {
      if (input.dataset.ucbPending !== "true") {
        input.checked = cart.items.some((item) => matches(item, input.dataset.ucbParent, input.dataset.ucbVariant));
      }
    });
    try {
      const jobs = {};
      const handles = {};
      cart.items.filter(isAddon).forEach((item) => {
        const parent = String(item.properties._refProdId);
        (jobs[parent] ||= {})[String(item.variant_id)] = { status: true };
        const parentItem = cart.items.find((line) => !isAddon(line) && String(line.product_id) === parent);
        if (parentItem) {
          const handle = parentItem.handle || parentItem.url?.split("/products/")[1]?.split("?")[0];
          if (handle) (handles[handle] ||= {})[String(item.variant_id)] = { status: true };
        }
      });
      localStorage.setItem("theUcbJobQueues", JSON.stringify(jobs));
      localStorage.setItem("theUcbCartQueues", JSON.stringify(handles));
    } catch (_) {}
  }

  function sectionsToRender() {
    const items = document.querySelector("cart-drawer-items") || document.querySelector("cart-items");
    return items?.getSectionsToRender?.() || [];
  }

  function renderCart(cart, sections) {
    const drawer = document.querySelector("cart-drawer");
    const wasOpen = drawer?.classList.contains("active");
    const previousFocus = document.activeElement;
    const focusedId = wasOpen && drawer.contains(previousFocus) ? previousFocus?.id : null;
    sections.forEach((section) => {
      const html = cart.sections?.[section.section];
      if (!html) return;
      const parsed = new DOMParser().parseFromString(html, "text/html");
      const targetRoot = document.getElementById(section.id);
      const target = targetRoot?.querySelector(section.selector) || targetRoot;
      const replacement = parsed.querySelector(section.selector);
      if (target && replacement) target.innerHTML = replacement.innerHTML;
    });
    drawer?.classList.toggle("is-empty", cart.item_count === 0);
    document.querySelector("cart-items")?.classList.toggle("is-empty", cart.item_count === 0);
    document.getElementById("main-cart-footer")?.classList.toggle("is-empty", cart.item_count === 0);
    drawer?.addCloseButtonHandlers?.();
    if (wasOpen) {
      // An already open drawer does not transition again after its contents change.
      if (drawer._openTransitionHandler) {
        drawer.removeEventListener("transitionend", drawer._openTransitionHandler);
        drawer._openTransitionHandler = null;
      }
      const note = drawer.querySelector('[id^="Details-"] summary');
      if (note && !note.hasAttribute("role")) drawer.setSummaryAccessibility?.(note);
      const container = cart.item_count === 0 ? drawer.querySelector(".drawer__inner-empty") : document.getElementById("CartDrawer");
      const replacementFocus = focusedId ? document.getElementById(focusedId) : null;
      const focus = container?.contains(previousFocus) ? previousFocus : container?.contains(replacementFocus) ? replacementFocus : drawer.querySelector(".drawer__inner") || drawer.querySelector(".drawer__close");
      if (container && focus && typeof trapFocus === "function") trapFocus(container, focus);
    }
  }

  async function update(updates) {
    const sections = sectionsToRender();
    const cart = await request("cart/update.js", {
      updates,
      sections: sections.map((section) => section.section),
      sections_url: window.location.pathname + window.location.search,
    });
    renderCart(cart, sections);
    return cart;
  }

  function announce(cart) {
    cartState = cart;
    synchronize(cart);
    document.dispatchEvent(new CustomEvent("cart:change", { detail: { cart, sectionId: source } }));
  }

  function showError(input, message) {
    const widget = input.closest(".theUcbUniqueProd");
    let error = widget?.querySelector(".fifth-avenue-upsell-error");
    if (!error && widget) {
      error = document.createElement("p");
      error.className = "fifth-avenue-upsell-error";
      error.setAttribute("role", "alert");
      widget.append(error);
    }
    if (error) error.textContent = message;
  }

  window.scheduleUcbProdAdd = function (input, parent, variant) {
    const checked = input.checked;
    if (nativeAddPending()) {
      input.checked = !checked;
      synchronize(cartState);
      showError(input, "Please wait for your item to finish adding, then select this add-on.");
      return;
    }
    input.dataset.ucbPending = "true";
    pendingSelections += 1;
    lockProductForms();
    showError(input, "");
    enqueue(async () => {
      let cart = await request("cart.js");
      const existing = cart.items.filter((item) => matches(item, parent, variant));
      if (checked && !existing.length) {
        const sections = sectionsToRender();
        const added = await request("cart/add.js", {
          items: [{ id: variant, quantity: 1, properties: {
            _ucbProduct: "yes",
            _refProdId: String(parent),
            _refProdTitle: input.dataset.ucbTitle || "",
          } }],
          sections: sections.map((section) => section.section),
          sections_url: window.location.pathname + window.location.search,
        });
        cart = await request("cart.js");
        cart.sections = added.sections;
        renderCart(cart, sections);
      } else if (!checked && existing.length) {
        cart = await update(Object.fromEntries(existing.map((item) => [item.key, 0])));
      }
      announce(cart);
    }).catch(async (error) => {
      input.checked = !checked;
      showError(input, error.message);
      try { cartState = await request("cart.js"); } catch (_) {}
    }).finally(() => {
      delete input.dataset.ucbPending;
      releaseProductForms();
      synchronize(cartState);
    });
  };

  document.addEventListener("cart:change", (event) => {
    if (event.detail?.sectionId === source || !event.detail?.cart?.items) return;
    const next = event.detail.cart;
    const previousParents = parentIds(cartState);
    const nextParents = parentIds(next);
    const removed = [...previousParents].filter((parent) => !nextParents.has(parent));
    cartState = next;
    synchronize(next);
    if (!removed.length) return;
    enqueue(async () => {
      let cart = await request("cart.js");
      const currentParents = parentIds(cart);
      const orphaned = cart.items.filter((item) => isAddon(item) && removed.includes(String(item.properties._refProdId)) && !currentParents.has(String(item.properties._refProdId)));
      if (orphaned.length) cart = await update(Object.fromEntries(orphaned.map((item) => [item.key, 0])));
      announce(cart);
    }).catch((error) => {
      document.dispatchEvent(new CustomEvent("cart:error", { detail: { source, message: error.message, errors: error.message } }));
    });
  });

  function initialize() {
    enqueue(async () => {
      if (document.querySelector(selector) || document.querySelector("cart-items, cart-drawer-items")) {
        cartState = await request("cart.js");
        synchronize(cartState);
      }
    }).catch(() => {});
    new MutationObserver((changes) => {
      if (changes.some((change) => [...change.addedNodes].some((node) => node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))))) {
        lockProductForms();
        synchronize(cartState);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initialize, { once: true });
  else initialize();
})();
